<template>
  <div class="CustomerNote">
    <BaseTextArea
        v-model="field.customerNote"
        :label="field.customerNotePrompt"
        :maxlength="350"
        :smaller="true"
        inline>
    </BaseTextArea>
  </div>
</template>

<script>
export default {
  props: {
    field: Object
  }
}
</script>

<style lang="scss" scoped>
.CustomerNote {
  margin-top: 1em;
}
</style>
